<template>
  <div>
    <div class="bg-primary"><!-- 2026-01-14 bg-primary 추가 -->
      <div class="header">
        <a href="javascript:void(0)" class="mainStLstBackBtn" @click="backBtn"></a>
        <div class="title" v-if="isScroll">주문 가능 지역</div>
      </div>
      <div class="banner">
        <img src="@/assets/img/banner-new-store-list-onnuri-kor.png" alt="" />
      </div>
      <div class="tab-wrap" :class="{ fixed: isScroll }">
        <ul class="tab-list" v-if="areaList.length > 0">
          <li
            v-for="(area, index) in areaList"
            :key="index"
            :class="{ active: activeArea === index }"
            @click="tabChangeHandler(area)"
          >
            <span>{{ area.upperAreaName }}</span>
            <span>{{ area.areaName }}</span>
          </li>
        </ul>
      </div>
      <div class="store-list" v-if="storeListShow">
        <div class="mainStLstBg">
        <ul v-if="list.length > 0">
          <li class="mainStLst" v-for="(item,index) in list" :key="index" @click="reqQr(item.storeCode,item.menuExistFlag)">
            <div class="zone-left">
              <div class="comingSoon" v-if="item.menuExistFlag === 0">
                {{$t('QR.openingSoon')}}
              </div>
              <div class="alive" v-else-if="item.aliveFlag">
                <p>{{$t('QR.closed')}}</p>
              </div>
              <!-- storeImageUrl 이미지url을 이용해서 표시 -->
              <img v-if="item.storeImageUrl" :src="item.storeImageUrl" alt="">
              <!-- 기본이미지 -->
              <img v-else :src="defaultImg" alt="">
            </div>
            <!-- TODO : 2025-12-10 명동 포장 관련 임시, 아래 v-if 조건만 삭제 -->
            <div class="zone-right" v-if="!isTakeOutStoreIncluded(item.storeCode)">
              <!-- <img src="@/assets/img/tag-onnuri-list.png" style="width:142px; height:24px; margin-bottom:4px;" v-if="item.serviceType" alt=""> -->
              <!-- <p class="marketName" v-if="item.marketName">{{item.marketName}}</p> -->
              <p class="name">{{item.storeName}}</p>
              <p class="text">
                <span class="sp1">{{$t('QR.deliveryFee')}}</span>
                <template v-if="(item.from === 0 && item.to === 0) || item.deliveryFeeFlag">
                  <span></span>
                </template>
                <template v-else-if="item.from === item.to">
                  <span class="sp2" :class="{free:item.deliveryFeeFlag}">{{formatComma(item.from)}}원</span>
                </template>
                <template v-else>
                  <span class="sp2">{{formatComma(item.from)}}원 ~ {{formatComma(item.to)}}원</span>
                </template>
                <span class="freeTag" v-if="item.from === 0 && item.to === 0">무료</span>
                <span class="freeTag" v-else-if="item.deliveryFeeFlag">무료</span>
                <span class="distance" v-if="item.distance !== undefined"><img src="../assets/img/ic_distance.png" alt="">{{item.distance + 'km'}}</span>
                <span class="package" v-if="item.usePickup">{{$t('QR.toGoOK')}}</span>
              </p>
            </div>
            <!-- TODO : 2025-12-10 명동 포장 관련 임시, 아래 v-else 문 삭제 -->
            <div class="zone-right" v-else>
              <!-- <img src="../assets/img/tag-onnuri-list.png" style="width:142px; height:24px; margin-bottom:4px;" v-if="item.serviceType" alt=""> -->
              <!-- <p class="marketName" v-if="item.marketName">{{item.marketName}}</p> -->
              <p class="name">{{item.storeName}}</p>
              <p class="info-box">
                <span class="package">{{$t('QR.toGoOK')}}</span>&nbsp;
                <span class="no-delivery">배달불가</span>
              </p>
            </div>
          </li>
          <template v-if="!isLastPage">
            <InfiniteLoading @infinite="storeList(true)" />
          </template>
        </ul>
        <ul v-else>
          <div class="noFranchisee">
            <div class="noFranchiseeImg"></div>
            <p>지금은 주문할 수 있는<br>가게가 없습니다.</p>
          </div>
        </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from '@/backend/modnpay_app_api'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'AppOpenAreaContainer',
  components: { InfiniteLoading },
  data () {
    return {
      list: [],
      areaList: [],
      reqAreaCode: '',
      isLastPage: '',
      address: '',
      page: 0,
      activeArea: 0,
      isScroll: false,
      storeListShow: false
    }
  },
  computed: {
    isKo () {
      return this.$i18n.locale === 'ko'
    },
    isEn () {
      return this.$i18n.locale === 'en'
    },
    isCn () {
      return this.$i18n.locale === 'cn'
    },
    defaultImg () { return require('@/assets/img/list_img_empty.png') }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    this.address = sessionStorage.getItem('selectAddress')
    this.openAreaList()

    // 메서드 호출하지 않고 바인딩한 함수 참조를 저장 후 전역에 할당
    this._boundBackBtn = this.backBtn.bind(this)
    window.backBtn = this._boundBackBtn
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
    // 동일 참조일 때만 제거
    if (window.backBtn === this._boundBackBtn) {
      try { delete window.backBtn } catch (e) { window.backBtn = undefined }
    }
  },
  methods: {
    backBtn () {
      console.log(' ::::: BACK BUTTON CLICKED ::::: ')

      sessionStorage.removeItem('reqAreaCode')
      sessionStorage.removeItem('openAreaAccept')
      this.appMoveMain()
    },
    handleScroll () {
      this.isScroll = window.scrollY > 10
    },
    async openAreaList () {
      const { data } = await service.openAreaList({ time: 0 })

      if (data.resultCode === 0) {
        this.areaList = data.openAreaDtoList || []

        if (data.openAreaDtoList.length > 0) {
          const beforeAreaCode = sessionStorage.getItem('reqAreaCode')

          if (beforeAreaCode) {
            this.activeArea = data.openAreaDtoList.findIndex(area => area.areaCode === beforeAreaCode)
            this.reqAreaCode = beforeAreaCode
          } else {
            this.reqAreaCode = data.openAreaDtoList[0].areaCode
          }

          this.storeList(false).then()
        }
      }
    },
    async storeList (isLoadMore = false) {
      const parseAddress = JSON.parse(this.address)
      const page = isLoadMore ? this.page + 1 : this.page
      if (isLoadMore) this.page = page

      let req = {
        areaCode: this.reqAreaCode,
        addressByLotNum: this.addressByLotNum,
        page: this.page,
        time: this.time
      }

      if (parseAddress) {
        req = {
          ...req,
          district: parseAddress.emdNm,
          gpsX: parseAddress.x !== undefined ? parseAddress.x : parseAddress.gpsX,
          gpsY: parseAddress.y !== undefined ? parseAddress.y : parseAddress.gpsY
        }
      }

      const { data } = await service.openAreaStoreList(req)
      if (data.resultCode === 0) {
        this.loadMoreAdd(data, isLoadMore)
      }
    },
    loadMoreAdd (data, isLoadMore) {
      this.isLastPage = data?.isLastPage
      const storeList = data.orderGroupDtoList.map(item => {
        return {
          ...item,
          from: item.from ?? 0,
          to: item.to ?? 0
        }
      })
      if (!isLoadMore) {
        this.list = storeList
        sessionStorage.getItem('langType')
          ? this.$i18n.locale = sessionStorage.getItem('langType')
          : this.$i18n.locale = this.$store.getters.langType
      } else {
        this.list.push(...storeList)
      }

      this.storeListShow = true
    },
    async reqQr (code, menuExistFlag) { // 매장 QR URL 요청
      const res = await service.storeIntroUrl({ urlCode: code })
      if (menuExistFlag === 0) {
        this.showSingleBtnDialogFlag = true
      } else if (res.data.resultCode === 0) {
        let baseUrl = res.data.introUrl
        const currentURL = window.location.href
        if (currentURL.indexOf('localhost') !== -1) {
          baseUrl = 'http://localhost:8004/menu/modn/mobile/ui/main?token=eyJ0b2tlbiI6ImQzMmU2NTlmLWQ3MGItNDM2Yy05YmNhLTNlNGE0ZmY5YzExYiIsIm9yZGVyU2VxIjoiMjMxMjAxMDA1MDYwNjIiLCJzdG9yZUNvZGUiOjI2MjYsInN0b3JlTmFtZSI6IuuqqOuToCDrtoTsi50iLCJvcmRlclRva2VuIjoiNDE0Mzc1MjEzYjEwNDUzNTA4MzU0MTljOWMxZmNmMTYxOTI1MmNiYzU4N2ViZDMzY2EiLCJ0YWJsZU5vIjotMSwiY2FyZENvZGUiOiIwMDAiLCJjcmVkaXQiOnRydWUsInFyVHlwZSI6MSwiYWxpdmUiOmZhbHNlfQ%3D%3D'
        }
        sessionStorage.setItem('reqAreaCode', this.reqAreaCode)
        sessionStorage.setItem('openAreaAccept', true)
        window.location.href = baseUrl// 가맹점 QR URL 리다이렉트하기
      } else {
        this.toast(this, res.data.resultMsg)
      }
    },
    tabChangeHandler (area) {
      this.activeArea = this.areaList.indexOf(area)
      this.addressByLotNum = area.addressByLotNum
      this.reqAreaCode = area.areaCode
      this.page = 0
      this.storeList(false).then()
    }
  }
}
</script>

<style lang="scss" scoped>
//2026-01-14
.bg-primary {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: var(--primary);
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  height: 56px;
  padding: 8px;
  background-color: var(--primary);
  z-index: 10;
  .title {
    font-size: 18px;
    font-weight: bold;
    color: #fff;
  }
}
.banner {
  img {
    max-width: 100%;
  }
}
.tab {
  &-wrap {
    background-color: #fff;
    border-bottom: 1px solid #e9e9e9;
    &.fixed {
      position: fixed;
      top: 56px;
      left: 0;
      right: 0;
      z-index: 10;
    }
  }
  &-list {
    display: flex;
    overflow-x: auto;
    li {
      flex: 1;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: 60px;
      padding: 0 20px;
      font-size: 15px;
      text-align: center;
      color: #818181;
      border-bottom: 4px solid #fff;
      span {
        white-space: nowrap;
      }
      &.active {
        color: var(--primary);
        border-bottom-color: var(--primary);
        font-weight: bold;
      }
    }
  }
  &-title {
    padding: 12px 16px 8px;
    font-size: 15px;
    font-weight: bold;
    color: var(--primary);
  }
}
//2026-01-14
.store-list {
  position: relative;
  flex: 1;
  //padding-top: 12px;
  background-color: #fff;
  .mainStLst {
    .zone {
      &-left {
        flex-shrink: 0;
        img {
          width: 64px;
        }
      }
      &-right {
        flex: 1;
        width: fit-content;
      }
    }
  }
}
</style>
